import script from "./ExportFormulareComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportFormulareComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ExportFormulareComponent.vue?vue&type=style&index=0&id=370444df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370444df"]])

export default __exports__